import React from 'react';

import Typography from '@mui/material/Typography';

import { RowContainer } from './styledInfoComponents';
import EditableField from './EditableField';
type Props = {
    value: string;
} & (
    | {
          editable?: false;
      }
    | {
          editable: true;
          isEditing: boolean;
      }
);

const NotesRow = (props: React.PropsWithChildren<Props>) => {
    return (
        <RowContainer border={false}>
            {props.editable && props.isEditing ? (
                <EditableField
                    field="userRemarks"
                    multiline={{ maxRows: 3 }}
                    placeholder="-"
                    fullWidth
                    sx={{
                        '& .MuiInputBase-multiline': {
                            padding: 0,
                        },
                    }}
                ></EditableField>
            ) : (
                <Typography
                    fontWeight="bold"
                    whiteSpace="pre-wrap"
                    maxHeight={80}
                >
                    {props.value || '-'}
                </Typography>
            )}
        </RowContainer>
    );
};

export default NotesRow;
